import { t } from './i18n/index.js';
import { mainPlace, placeLabel, placesFor } from './model.js';
import { esc } from './ui.js';

/* Lesson location picker (Vor Ort / Online, or In der Schule / Beim Schüler / Online) and one price field per place. */
export function placeSeg(id,s,cur){
  return `<div class="seg placeseg" id="${id}" role="radiogroup" aria-label="${esc(t('place.title'))}">${placesFor(s).map(p=>
    `<button type="button" role="radio" data-place="${p}" aria-checked="${p===cur}" class="${p===cur?'on':''}">${esc(placeLabel(p,s))}</button>`).join('')}</div>`;
}
export function setPlaceSeg(box,p){box.querySelectorAll('[data-place]').forEach(b=>{const on=b.dataset.place===p;b.classList.toggle('on',on);b.setAttribute('aria-checked',String(on))})}
export function bindPlaceSeg(root,id,onChange){
  const box=root.querySelector('#'+id);if(!box)return;
  box.onclick=e=>{const b=e.target.closest('[data-place]');if(!b)return;setPlaceSeg(box,b.dataset.place);if(onChange)onChange(b.dataset.place)};
}
export const placeValue=(root,id)=>{const b=root.querySelector('#'+id+' [data-place].on');return b?b.dataset.place:null};

/** one number field per place. key(p) = the property holding that place's rate on obj; ph(p) = placeholder */
export function rateFields(pre,obj,s,key,ph){
  const ps=placesFor(s);
  return `<div class="${ps.length>2?'formrow3':'formrow'} ratefields">${ps.map(p=>{const v=obj?obj[key(p)]:null;
    return `<div class="field"><label for="${pre}-${p}">${esc(placeLabel(p,s))}</label><input class="input" type="number" min="0" step="0.5" inputmode="decimal" id="${pre}-${p}" value="${v!=null&&v!==''?esc(v):''}" placeholder="${esc(ph(p))}"></div>`}).join('')}</div>`;
}
/** read the fields back: {place: number|null} */
export function readRates(root,pre,s){const o={};for(const p of placesFor(s)){const el=root.querySelector('#'+pre+'-'+p);if(!el)continue;const v=parseFloat(el.value);o[p]=el.value!==''&&isFinite(v)&&v>=0?v:null}return o}
export const sameAs=s=>t('place.sameAs',{p:placeLabel(mainPlace(s),s)});
